<template class="ProductInterfaceList">
  <div>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      1.导出物料特性
      <el-input v-model.trim="parentMaterialList" placeholder="请输入物料名称，用英文逗号分隔" style="width:800px;margin-left: 5px"/>
      <el-button
          class="buttonStyle"
          type="primary"
          :loading="exportLoading"
          @click="exportExcel()">
        导出
      </el-button>
    </div>
    <div/>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      2.物料价格明细导出
      <el-input v-model.trim="materialName" placeholder="请输入物料名称，用英文逗号分隔" style="width:800px;margin-left: 5px"/>
      <el-input v-model.trim="cuPrice" placeholder="请输入铜价" style="width:100px;margin-left: 5px"/>
      <el-button
          class="buttonStyle"
          type="primary"
          :loading="exportLoading"
          @click="exportExcel2()">
        导出
      </el-button>
    </div>
    <div/>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      3.物料价格明细导入
      <el-upload action="" :http-request="updateMaterialPrice" :show-file-list="false" :file-list="fileList">
        <el-button :loading="priceImportLoading" type="primary" plain class="buttonStyle">物料价格明细导入</el-button>
      </el-upload>
    </div>
    <div/>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      4.根据物料名称导出选配价格
      <el-input v-model.trim="materialName2" placeholder="请输入单个物料名称" style="width:800px;margin-left: 5px"/>
      <el-button
          type="primary"
          class="buttonStyle"
          :loading="exportLoading"
          @click="exportExcel3()">
        导出
      </el-button>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      5.物料选配价格明细导入
      <el-upload action="" :http-request="updateOptionalPrice" :show-file-list="false" :file-list="fileList">
        <el-button :loading="priceImportLoading" type="primary" plain class="buttonStyle">物料选配价格明细导入</el-button>
      </el-upload>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      6.根据物料名称导出相关性
      <el-input v-model.trim="materialName3" placeholder="请输入单个物料名称" style="width:800px;margin-left: 5px"/>
      <el-button
          type="primary"
          class="buttonStyle"
          :loading="exportLoading"
          @click="exportExcel4()">
        导出
      </el-button>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      7.根据父级物料名称导出所有基础价格
      <el-input v-model.trim="materialName4" placeholder="请输入父级物料名称，用英文逗号分隔" style="width:800px;margin-left: 5px"/>
      <el-button
          type="primary"
          class="buttonStyle"
          :loading="exportLoading"
          @click="exportExcel5()">
        导出
      </el-button>
    </div>
    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 5px">
      8.根据父级物料名称导出所有选配价格
      <el-input v-model.trim="materialName5" placeholder="请输入父级物料名称，用英文逗号分隔" style="width:800px;margin-left: 5px"/>
      <el-button
          type="primary"
          class="buttonStyle"
          :loading="exportLoading"
          @click="exportExcel6()">
        导出
      </el-button>
    </div>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import auth from "@/util/loginUtil";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "ProductInterfaceList",
    components: {},
    data() {
      return {
        constant,
        exportLoading: false,
        priceImportLoading:false,
        admin: auth.getUserId() === 90,
        parentMaterialList: "",
        materialName:"",
        materialName2:"",
        materialName3:"",
        materialName4:"",
        materialName5:"",
        cuPrice:"",
        fileList: [],
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
    },
    methods: {
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .postForFile("basic", "materials/exportMaterialFeature",  this.parentMaterialList.split(","))
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      exportExcel2() {
        this.exportLoading = true;
        this.$http
          .postForFile("basic", `material_prices/exportMaterialPrice/${this.cuPrice}`,  this.materialName.split(","))
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      exportExcel3() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", `material_prices/selectOptionalPriceByMaterialName/${this.materialName2}`)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      exportExcel4() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", `rules/export/${this.materialName3}`)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      updateMaterialPrice(params) {
        this.priceImportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "material_prices/updateMaterialPrice", formData)
          .then(() => {
            this.priceImportLoading = false;
          })
          .catch((res) => {
            this.priceImportLoading = false;
            this.$message.error(res.message);
          });
      },

      updateOptionalPrice(params) {
        this.priceImportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "material_prices/updateMaterialOptionalPrice", formData)
          .then(() => {
            this.priceImportLoading = false;
          })
          .catch((res) => {
            this.priceImportLoading = false;
            this.$message.error(res.message);
          });
      },

      exportExcel5() {
        this.exportLoading = true;
        this.$http
          .postForFile("basic", "material_prices/selectPriceByParentList",  this.materialName4.split(","))
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      exportExcel6() {
        this.exportLoading = true;
        this.$http
          .postForFile("basic", "material_prices/selectOptionPriceByParentList",  this.materialName5.split(","))
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss">
.buttonStyle{
  margin-left: 5px;
}
</style>
